import { Component, OnInit, Inject } from '@angular/core';
import { DigitalFormServiceIdentity } from '../../../services/digital-form.service';
import { NotificationsService } from 'angular2-notifications';
import { DigitalFormQuestionTypesVM, GenericIdName, AddQuestionVM, QuestionAnswerList, ComponentTypeList, ImplementLoadVM, CompListVM, UnitMeasureVM } from '../../../models/digitalForm.model';
import { ConfirmDialogComponentIdentity } from '../confirm-dialog/confirm-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PreferencesService } from '../../../../preferences/preferences.service';
import { heicTo } from 'heic-to';

@Component({
  selector: 'app-add-formcategory',
  templateUrl: './add-formcategory.component.html',
  styleUrls: ['./add-formcategory.component.scss']
})
export class AddFormcategoryComponent implements OnInit {
  isSection: boolean = false;
  parentCatId: number;
  formId: number;
  sectionName: string;
  isQuestion: boolean = false;
  sectionId: number;
  QuestionTypes: DigitalFormQuestionTypesVM[] = [];
  CopyQuestionTypes: DigitalFormQuestionTypesVM[] = [];
  OptionOne: string = "True";
  OptionTwo: string = "False";
  StatWorn_1: number;
  StatWorn_2: number;
  EndWorn_1: number;
  EndWorn_2: number;
  Option: string;
  StartWorn: number;
  EndWorn: number;
  AnswerOptions: any[];
  ImageFile: File;
  imageUrl: string = '';
  QuestionDetails: AddQuestionVM;
  QTitle: string;
  QDescription: string;
  questionTypeId: number;
  AllowImageEdit: boolean = false;
  AllowImages: boolean = true;
  isCategoery: boolean = false;
  categoryName: string;
  isQuestionEdit: boolean = false;
  QuestionId: number;
  isCategoeryEdit: boolean = false;
  isParent: boolean = false;
  Name: string;
  ImplementTypesList: GenericIdName[] = [];
  impTypeId: number;
  componetTypesList: ComponentTypeList[] = [];
  ComponentList: ComponentTypeList[] = [];
  customerId: number[];
  notypes: boolean = false;
  nocomps: boolean = false;
  componentTypeIds: number[];
  componentIds: number[];
  modelId: number[];
  isCopied: boolean = false;
  isParentQuestion: boolean = false;
  isUpdateCat: number = 0;
  isEditQ: number = 0;
  IsMagnetic: boolean;
  IsConnectComp: boolean;
  componentTypeId: number;
  componentId: number;
  IsLimitActive: boolean;
  StatWorn_Num: number;
  EndWorn_Num: number;
  DecimalPlaces: number;
  SchematicList: string[];
  noComponentTypesMsg = false;
  noComponentMsg = false;
  showComponentTypes = false;
  showComponents = false;
  loading = false;
  unitMeasures: UnitMeasureVM[] = [];
  selectedUnit: string;
  selectedId:number;
  isMetric: boolean = false;
  userUOM: string = 'mm';
  selectedTypeId: number;
  isEdit: boolean = false;
  isAnswerMandatory: boolean = false;
  constructor(private _dialogRef: MatDialogRef<AddFormcategoryComponent>,
    private _formService: DigitalFormServiceIdentity, private _notification: NotificationsService,
    private _dialog: MatDialog, private _sanitizer: DomSanitizer, private _pref: PreferencesService,
    @Inject(MAT_DIALOG_DATA) private _data: any,) { }
  ngOnInit() {
    this.getUserUOM();
    //console.log("this.data", this._data)
    this.isUpdateCat = this._data.isUpdateCat;
    this.isEditQ = this._data.isEditQ;
    //add section
    this.parentCatId = this._data.parentCatId;
    this.isSection = this._data.isSection;
    this.formId = this._data.formId;
    //add Question
    this.isQuestion = this._data.isQuestion;
    this.sectionId = this._data.sectionId;
    this.QuestionTypes = this._data.QuestionTypes;
    this.CopyQuestionTypes = this._data.QuestionTypes;
    this.customerId = this._data.customerId;
    this.modelId = this._data.modelId;
    //add Category
    this.isCategoery = this._data.isCategoery;
    //edit section or cat
    this.isParent = this._data.isParent;
    this.Name = this._data.Name;
    this.isEdit = this._data.isEdit;
    this.isCategoeryEdit = this._data.isCategoeryEdit;
    if (this.isParent)
      this.categoryName = this.Name;
    else
      this.sectionName = this.Name;
    //edit question
    this.isQuestionEdit = this._data.isQuestionEdit;
    this.QuestionId = this._data.QuestionId;
    if (this.QuestionId > 0) {
      //loadQuestionIn
      this.QuestionDetails = this._data.QuestionDetails;
      console.log("Question details____", this.QuestionDetails)
      this.QTitle = this.QuestionDetails.QTitile;
      this.QDescription = this.QuestionDetails.QDescription;
      this.questionTypeId = this.QuestionDetails.QuestionTypeID;
      this.imageUrl = this.QuestionDetails.QuestionImage != null ? "data:image/jpeg;base64," + this.QuestionDetails.QuestionImage : null;
      this.AllowImageEdit = this.QuestionDetails.AllowImageEdit;
      this.AllowImages = this.QuestionDetails.AllowImages;
      this.isCopied = this.QuestionDetails.IsCopy;
      this.isParentQuestion = this.QuestionDetails.IsParent;
      this.IsMagnetic = this.QuestionDetails.IsMagnetic;
      this.IsConnectComp = this.QuestionDetails.IsComponentConnect;
      this.IsLimitActive = this.QuestionDetails.IsActiveLimits;
      // this.StatWorn_Num = this.convertToShowData(this.QuestionDetails.StartWornNum);
      // this.EndWorn_Num = this.convertToShowData(this.QuestionDetails.EndWornNum);
      this.DecimalPlaces = this.QuestionDetails.DecimalPlaces;
      const unit = this.QuestionDetails.UnitMeasureType?.toUpperCase() || '';
      this.selectedTypeId = (unit === 'MM' || unit === 'IN') ? 4 : (unit === 'KPA' || unit === 'PSI') ? 6 : (unit === 'DEG') ? 7 : null;
      this.isAnswerMandatory = this.QuestionDetails.IsAnswerMandatory;
      if (this.questionTypeId == 6 || this.IsConnectComp == true) {
        //console.log("customerlist____ and modellist", this.customerId, this.modelId)
        let params = new ImplementLoadVM();
        params.customer = this.customerId == undefined ? [] : this.customerId;
        params.models = this.modelId == undefined ? [] : this.modelId;
        //console.log("list", params)
        this._formService.GetFormLinkedTemplateType(this.formId).subscribe(res_ => {
          if (res_ == null || res_.length == 0) {
            this._formService.LoadImplmentTypes(params).subscribe(res => {
              this.ImplementTypesList = res;
              if (this.QuestionDetails.ImplementTypeId != null) {
                this.impTypeId = this.QuestionDetails.ImplementTypeId;
                this.LoadComponentTypes(this.impTypeId);
              } else {
                this.impTypeId = null;
              }
            })
          } else {
            this.ImplementTypesList = res_;
            if (this.QuestionDetails.ImplementTypeId != null) {
              this.impTypeId = this.QuestionDetails.ImplementTypeId;
              this.LoadComponentTypes(this.impTypeId);
            } else {
              this.impTypeId = null;
            }
          }
        })
      }
      else {
        this.notypes = true;
        this.nocomps = true;
        this.SchematicList = [];
      }
      if (this.questionTypeId == 1) {
        this.OptionOne = this.QuestionDetails.QuestionAnswer[0].Answer;
        this.OptionTwo = this.QuestionDetails.QuestionAnswer[1].Answer;
        this.StatWorn_1 = this.QuestionDetails.QuestionAnswer[0].WornStart;
        this.StatWorn_2 = this.QuestionDetails.QuestionAnswer[1].WornStart;
        this.EndWorn_1 = this.QuestionDetails.QuestionAnswer[0].WornEnd;
        this.EndWorn_2 = this.QuestionDetails.QuestionAnswer[1].WornEnd;
      }
      if (this.questionTypeId == 2 || this.questionTypeId == 3) {
        this.AnswerOptions = this.QuestionDetails.QuestionAnswer
        let arr_ = [];
        this.QuestionDetails.QuestionAnswer.map(x => {
          let obj = {
            Id: x.AnswerId,
            Name: x.Answer,
            StartWorn: x.WornStart,
            EndWorn: x.WornEnd
          }
          arr_.push(obj);
        })
        this.AnswerOptions = arr_;
      }
    }
  }
  onEditategory() {
    this._formService.EditcategoryOrSection(this.sectionId, this.Name, this.isUpdateCat).subscribe(res => {
      if (res > 0) {
        this._notification.success('Saved', 'Successfully Update');
        this._dialogRef.close(true)
      } else {
        this._notification.error('Failed', 'Failed to Update');
      }
    })
  }
  AddAnswerOption() {
    if (this.Option != null && this.Option != "") {
      this.optionupdate = true;
      //console.log("Options", this.AnswerOptions)
      let arr_ = [];
      if (this.AnswerOptions == null) {
        var object = {
          Id: 1,
          Name: this.Option,
          StartWorn: this.StartWorn,
          EndWorn: this.EndWorn,
        }
        arr_.push(object);
        this.Option = "";
        this.StartWorn = null;
        this.EndWorn = null;
        this.AnswerOptions = arr_;
      } else {
        let count = this.AnswerOptions.length + 1;
        var obj = {
          Id: count,
          Name: this.Option,
          StartWorn: this.StartWorn,
          EndWorn: this.EndWorn,
        }
        this.Option = "";
        this.StartWorn = null;
        this.EndWorn = null;
        this.AnswerOptions.push(obj);
      }
    }
  }
  RemoveAnswerOption(Id: number) {
    this.optionupdate = true;
    //console.log("Id",Id)
    this.AnswerOptions = this.AnswerOptions.filter(x => x.Id != Id);
  }
  updateFlag() {
    this.optionupdate = true;
  }
  onAddSection() {
    this._formService.AddNewSection(this.formId, this.parentCatId, this.sectionName).subscribe(res => {
      if (res > 0) {
        this._notification.success('Saved', 'Successfully Saved Section');
        this._dialogRef.close(true)
      } else {
        this._notification.error('Failed', 'Failed to save section');
      }
    })
  }
  onAddCategory() {
    this._formService.AddNewcategory(this.formId, this.categoryName).subscribe(res => {
      if (res > 0) {
        this._notification.success('Saved', 'Successfully added new Category');
        this._dialogRef.close(true)
      } else {
        this._notification.error('Failed', 'Failed to save category');
      }
    })
  }
  ShowMagnetic: boolean = false;
  ChangeOption() {
    //this.AnswerOptions = null;
    //this.componetTypesList = [];
    //this.ImplementTypesList = [];
    ////this.impTypeId = null;
    ////this.notypes = true;
    ////this.nocomps = true;
    //this.componentTypeIds = [];
    //this.componentIds = [];
    this.noComponentTypesMsg = false;
    this.showComponentTypes = false;
    this.noComponentMsg = false;
    this.showComponents = false;
    this.ShowMagnetic = false;
    if (this.questionTypeId > 5 || this.IsConnectComp == true) {
      let params = new ImplementLoadVM();
      params.customer = this.customerId == undefined ? [] : this.customerId;
      params.models = this.modelId == undefined ? [] : this.modelId;
      //console.log("list", params)
      this._formService.GetFormLinkedTemplateType(this.formId).subscribe(res_ => {
        console.log("res_", res_);
        if (res_.length == null || res_.length == 0) {
          this._formService.LoadImplmentTypes(params).subscribe(res => {
            this.ImplementTypesList = res;
            console.log(this.ImplementTypesList);
          })
        } else {
          this.ImplementTypesList = res_;
          console.log(this.ImplementTypesList);
        }
      })
    }
    if (this.questionTypeId == 2) {
      this.ShowMagnetic = true;
    }
   if (this.questionTypeId == 5) {
      this.IsLimitActive = true;
    }
  }
  ImageName: string;
  // onSelectImage(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]); // read file as data url
  //     this.ImageFile = event.target.files[0];
  //     reader.onload = (event: any) => { // called once readAsDataURL is completed
  //       this.imageUrl = event.target["result"];
  //       this.ImageName = this.ImageFile.name;
  //     }
  //     this.AllowImageEdit = true;
  //     this.AllowImages = true;
  //   }
  // }
  

// onSelectImage(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       this.ImageFile = f;
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: any) => {
//         const result = e.target.result as string;
//         this.imageUrl = result;
//         this.ImageName = f.name;
//       };
//       this.AllowImageEdit = true;
//       this.AllowImages = true;
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this._notification.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null; // 🔥 allow same file reselect
//   }
// }

  async onSelectImage(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    this.ImageFile = f;

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const result = e.target.result as string;

      this.imageUrl = result;
      this.ImageName = f.name;

    };

    reader.readAsDataURL(f);

    this.AllowImageEdit = true;
    this.AllowImages = true;

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this._notification.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  onLimitActiveChange(isChecked: boolean): void {
    this.IsLimitActive = isChecked;
  }

  toggleIsMagnetic() {
    //console.log("IsmGnetic", this.IsMagnetic)
    this._formService.UpdateIsMagetic(this.QuestionId).subscribe(res => {
      if (res > 0)
        this._notification.success('Updated', 'Update Magnetic Plug Question')
      else
        this._notification.error('Failed', 'Failed to update Magnetic Plug Question')
    })
  }
  toggleIsLimitActive() {
    //console.log("isActiveLimit", this.IsLimitActive)
    this._formService.UpdateActivateLimits(this.QuestionId).subscribe(res => {
      if (res > 0)
        this._notification.success('Updated', 'Update Activate Limits for Answers')
      else
        this._notification.error('Failed', 'Failed to update Activate Limits for Answers')
    })
  }
  onNoClick() {
    this.optionupdate = false;
    this._dialogRef.close(false);
  }
  optionupdate: boolean = false;
  onAddQuestion() {
    //console.log("Image URL", this.ImageName)
    var info = new AddQuestionVM();
    info.FormId = this.formId;
    info.QTitile = this.QTitle;
    info.QDescription = this.QDescription;
    info.QuestionTypeID = this.questionTypeId;
    info.AllowImageEdit = this.AllowImageEdit;
    info.AllowImages = this.AllowImages;
    info.ImplementTypeId = null;
    info.QuestionImage = this.ImageName != undefined ? this.imageUrl.split(',')[1] : "";
    info.QuestionSectionId = this.sectionId;
    info.ComponentTypeId = this.componentTypeIds;
    info.ComponentId = this.componentIds;
    info.ImplementTypeId = this.impTypeId;
    info.isEditQ = this.isEditQ;
    info.OptionUpdate = this.optionupdate;
    info.IsMagnetic = this.questionTypeId == 2 ? this.IsMagnetic : false;
    info.IsComponentConnect = this.IsConnectComp;
    info.IsActiveLimits = this.IsLimitActive;
    info.StartWornNum = this.questionTypeId == 5 ? this.convertToSaveData(this.StatWorn_Num) : this.StatWorn_Num;
    info.EndWornNum = this.questionTypeId == 5 ? this.convertToSaveData(this.EndWorn_Num) : this.EndWorn_Num;
    info.DecimalPlaces = this.DecimalPlaces;
    info.UnitMeasureType = this.selectedTypeId == 6 ?  'KPA' : this.selectedTypeId == 4 ? 'MM' : this.selectedTypeId == 7 ? 'DEG' : '';
    info.IsAnswerMandatory = this.isAnswerMandatory;
    let arr_ = [];
    if (this.QTitle == null || this.questionTypeId <= 0 || this.questionTypeId == undefined) {
      this._notification.error('Missing Required Field (*)', 'Please fill in all required fields. ');
      return;
    }
    //if (this.IsConnectComp == true) {
    //  if (this.componentIds.length == 0 || this.componentIds == []) {
    //    this._notification.error('Please select Component to link this question');
    //    return;
    //  }
    //}
   
    if (this.questionTypeId == 2 || this.questionTypeId == 3) {
      this.AnswerOptions.map(x => {
        var ans = new QuestionAnswerList();
        ans.formId = this.formId;
        ans.Answer = x.Name;
        ans.AnswerId = x.Id;
        ans.WornStart = x.StartWorn;
        ans.WornEnd = x.EndWorn;
        let obj = {
          formId: this.formId,
          Answer: x.Name,
          AnswerId: x.Id,
          WornStart: x.StartWorn,
          WornEnd: x.EndWorn,
        }
        arr_.push(obj);
      })
      info.QuestionAnswer = arr_;
    } else if (this.questionTypeId == 1) {
      arr_ = [];
      var ans = new QuestionAnswerList();
      let obj_1 = {
        formId: this.formId,
        Answer: this.OptionOne,
        AnswerId: 1,
        WornStart: this.StatWorn_1,
        WornEnd: this.EndWorn_1
      }
      arr_.push(obj_1);
      let obj_2 = {
        formId: this.formId,
        Answer: this.OptionTwo,
        AnswerId: 1,
        WornStart: this.StatWorn_2,
        WornEnd: this.EndWorn_2
      }
      arr_.push(obj_2);
      info.QuestionAnswer = arr_;
    }
    else if (this.questionTypeId == 6) {
      info.ComponentTypeId = this.componentTypeIds;
      info.ImplementTypeId = this.impTypeId;
      if (this.impTypeId == null) {
        this._notification.error('Please select Implement to link this question');
        return;
      }
    }
    //console.log("info__", info)
    if (this.isQuestionEdit) {
      //update
      info.QuestionId = this.QuestionId;
      if (this.isParentQuestion == true && this.isCopied == false) {
        //console.log("info__11", this.isParentQuestion,this.isCopied)
        //show dialog
        const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
          // width: '700px',
          // height:'250px',
          data: {
            open: true,
            isCopied: false,
            isParent: true,
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
          if (details > 0) {
            info.IsParent = true;
            info.IsRemoveLink = details;
            this.UpdateQuestion(info);
          }
        });
      }
      else if (this.isCopied == true && this.isParentQuestion == false) {
        //console.log("info__22", this.isParentQuestion,this.isCopied)
        //show dialog
        const addSectionDialog = this._dialog.open(ConfirmDialogComponentIdentity, {
          // width: '700px',
          // height:'250px',
          data: {
            open: true,
            isCopied: true,
            isParent: false,
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
          if (details == 1) {
            info.IsParent = false;
            info.IsRemoveLink = 0;
            this.UpdateQuestion(info);
          }
        });
      } else if (this.isCopied == false && this.isParentQuestion == false) {
        //console.log("info__33", this.isParentQuestion,this.isCopied)
        this.UpdateQuestion(info);
      }
    } else {
      //create new Question
      this.loading = true;
      this._formService.AddNewQuestion(info).subscribe(res => {
        if (res) {
          this.loading = false;
          this._notification.success('Saved', 'Successfully Saved Question');
          this._dialogRef.close(true)
        } else {
          this.loading = false;
          this._notification.error('Failed', 'Failed to save Question');
        }
      });
    }
  }
  UpdateQuestion(info) {
    this.loading = true;
    this._formService.EditQuestion(info).subscribe(res => {
      if (res) {
        this.loading = false;
        this._notification.success('Updated', 'Successfully update Question');
        this.optionupdate = false;
        this._dialogRef.close(true)
      } else {
        this.loading = false;
        this._notification.error('Failed', 'Failed to save Question');
      }
    });
  }
  selectedTemplate: number
  LoadComponentTypes(impTypeId: number) {
    this.noComponentTypesMsg = false;
    this.showComponentTypes = false;
    this.componetTypesList = [];
    this.impTypeId = impTypeId;
    console.log("impTypeId", this.impTypeId)
    this.selectedTemplate = 0;
    if (this.impTypeId > 0)
      this.selectedTemplate = this.ImplementTypesList.find(x => x.ImplementTypeId == this.impTypeId).Id;
    this._formService.GetComponentTypes(this.selectedTemplate, this.formId).subscribe(res => {
      this.componetTypesList = res;
      //console.log("")
      if (this.componetTypesList.length == 0) {
        this.notypes = true;
        this.noComponentTypesMsg = true;
      }
      else {
        this.showComponentTypes = true;
        this.notypes = false;
      }
      if (this.isQuestionEdit) {
        this.componentTypeIds = this.QuestionDetails.ComponentTypeId;
        if (this.componentTypeIds != null) {
          this.componentTypeId = this.componentTypeIds[0];
          this.componentTypeIds.map(x => {
            this.componetTypesList.map(res => {
              if (x == res.Id) {
                res.Checked = true;
              }
            })
          })
        }
        else
          this.componentTypeId = 0;
        this.LoadComponent();
        //console.log("dajdba",this.componetTypesList)
      }
    })
  }
  LoadComponent() {
    //if (this.IsConnectComp == true) {
    //  let arry_ = [];
    //  arry_.push(this.componentTypeId);
    //  this.componentTypeIds = arry_;
    //}
    let arry_ = [];
    arry_.push(this.componentTypeId);
    this.componentTypeIds = arry_;
    this.noComponentMsg = false;
    this.showComponents = false;
    //console.log("Res11111", this.componentTypeIds)
    //this.ComponentList=[];
    let params = new CompListVM();
    params.compoenetTypeIds = this.componentTypeIds;
    params.FormId = this.formId;
    this._formService.GetCompoentsAvailable(params).subscribe(res => {
      this.ComponentList = res;
      //console.log("ComponentList__", this.ComponentList)
      if (this.ComponentList.length == 0) {
        this.nocomps = true;
        this.noComponentMsg = true;
      }
      else {
        this.showComponents = true;
        this.nocomps = false;
      }
      if (this.isQuestionEdit) {
        //console.log("Compselected", this.QuestionDetails.ComponentId)
        this.componentIds = this.QuestionDetails.ComponentId;
        this.ShowSchematicList();
        this.componentIds.map(x => {
          this.ComponentList.map(res => {
            if (x == res.Id) {
              res.Checked = true;
              this.componentId = x;
            }
          })
        })
        //console.log("ComponentList___",this.ComponentList)
      }
    })
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }
 
  ShowSchematicList() {
    //console.log("componentIds", this.componentIds)
    if (this.componentIds != null) {
      let newImageList = [];
      this.componentIds.map(x => {
        let imageList = [];
        this.ComponentList.map(c => {
          if (c.Id == x) {
            imageList = c.SchematicImages;
          }
        })
        newImageList = imageList;
      })
      this.SchematicList = newImageList;
    }
  }
  //component connect chnages
  toggleIsConnectComp() {
    //console.log("IsConnectComp", this.IsConnectComp)
    //this.questionTypeId = 0;
    //this.AnswerOptions = null;
    //this.componetTypesList = [];
    //this.ImplementTypesList = [];
    //this.impTypeId = null;
    //this.notypes = true;
    //this.nocomps = true;
    //this.componentTypeIds = [];
    //this.componentIds = [];
    this.ShowMagnetic = false;
    if (this.IsConnectComp == true) {
      this.QuestionTypes = this.QuestionTypes.filter(x => x.Id != 6);
      //if (this.questionTypeId > 0) {
      //  let params = new ImplementLoadVM();
      //  params.customer = this.customerId == undefined ? [] : this.customerId;
      //  params.models = this.modelId == undefined ? [] : this.modelId;
      //  //console.log("list", params)
      //  this._formService.LoadImplmentTypes(params).subscribe(res => {
      //    this.ImplementTypesList = res;
      //  })
      //}
    } else {
      this.QuestionTypes = this.CopyQuestionTypes;
      this.showComponentTypes = false;
      this.showComponents = false;
      this.noComponentTypesMsg = false;
      this.noComponentMsg = false;
    }
  }
  PushToComponentId() {
    let arr_ = [];
    this.componentIds = [];
    arr_.push(this.componentId);
    this.componentIds = arr_;
  }
  
  toggleIsAnswerMandatory() {
    this.isAnswerMandatory = !this.isAnswerMandatory;
    console.log("isAnswerMandatory", this.isAnswerMandatory);
  }

  // getUnitMeasures() {
  //   this._formService.getUnitMeasures().subscribe(res => {
  //     this.unitMeasures = res.Data;
  //     this.selectedId = this.QuestionDetails.UnitMeasureType.length > 0 ? this.unitMeasures.find(u => u.UnitMeasure.toLowerCase() === this.QuestionDetails.UnitMeasureType.toLowerCase())?.UnitId : this.unitMeasures[0].UnitId;    
  //     console.log("Unit Measures", res);
  //   });
  // }
  onUnitTypeSelected(event: any): void {
    console.log('Selected Unit Type ID:', event);
    this.selectedTypeId = event;
    this._formService.getUnitMeasures(event).subscribe(res => {
      if(this.userUOM == "mm"){
        this.unitMeasures = res.Data.filter(u => u.UnitMeasure.toLowerCase() == "mm" || u.UnitMeasure.toLowerCase() == "kpa"|| u.UnitMeasure.toLowerCase() == "deg"  );
      }
      else{
        this.unitMeasures = res.Data.filter(u => u.UnitMeasure.toLowerCase() == "in" || u.UnitMeasure.toLowerCase() == "psi"  );
      }
      console.log("unitMeasures",this.unitMeasures);
      this.selectedId = this.unitMeasures.length > 0 ? this.unitMeasures[0].UnitId : null;
      console.log("selectedId",this.selectedId);
      console.log("Unit Measures", res);
    });
  }

  onUnitSelected(selectedUnitId: number): void {
    const selectedUnit = this.unitMeasures.find(u => u.UnitId === selectedUnitId);
    console.log('Selected Unit:', selectedUnit);
    this.selectedUnit = selectedUnit.UnitMeasure;
    this.selectedId = selectedUnit.UnitId;
  }

  getUserUOM(){
    this._pref.getGeneralTabPreferences().subscribe(res => {
      console.log("User UOM Preference", res);
      this.isMetric = res.UnitOfMeasurementName.toLowerCase() == 'mm' ? true : false;
      this.userUOM = res.UnitOfMeasurementName;
      if(this.isEdit){
        this.onUnitTypeSelected(this.selectedTypeId);
        this.StatWorn_Num = this.convertToShowData(this.QuestionDetails.StartWornNum);
        this.EndWorn_Num = this.convertToShowData(this.QuestionDetails.EndWornNum);
      }
    });
  }

convertToSaveData(value: number): number {
  if (!this.isMetric) {
    if (this.selectedTypeId == 6) {
      return parseFloat((value * 6.89476)?.toFixed(2));
    }
    else if (this.selectedTypeId == 4) {
      return parseFloat((value * 25.4)?.toFixed(2));
    }
  }
  return parseFloat(value?.toFixed(2));
}

convertToShowData(value: number): number {
  if (!this.isMetric) {
    if (this.selectedTypeId == 6) {
      return parseFloat((value / 6.89476)?.toFixed(2));
    }
    else if (this.selectedTypeId == 4) {
      return parseFloat((value / 25.4)?.toFixed(2));
    }
  }
  return parseFloat(value?.toFixed(2));
}
}
